(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["purekana-product-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, format) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format);
      }

      const amount = (Number(cents || 0) / 100).toFixed(2);
      const token = (name) => '{' + '{' + name + '}' + '}';
      return (format || `$${token('amount')}`)
        .split(token('amount_no_decimals')).join(Math.round(Number(cents || 0) / 100).toString())
        .split(token('amount')).join(amount)
        .split(token('amount_with_comma_separator')).join(amount.replace('.', ','));
    };

    const initSection = (root) => {
      if (!root || root.dataset.pkInitialized === 'true') return;

      const variantsNode = root.querySelector('[data-pk-variants-json]');
      const form = root.querySelector('.pk-product-offer__form');
      if (!variantsNode || !form) return;

      root.dataset.pkInitialized = 'true';

      let variants = [];
      try {
        variants = JSON.parse(variantsNode.textContent);
      } catch (error) {
        return;
      }

      const mainImage = root.querySelector('.pk-product-offer__main-image');
      const variantInput = root.querySelector('[data-pk-variant-input]');
      const quantityInput = root.querySelector('[data-pk-quantity-input]');
      const buyButton = root.querySelector('[data-pk-buy-button]');
      const buttonLabel = root.querySelector('[data-pk-button-label]');
      const buttonPrice = root.querySelector('[data-pk-button-price]');
      const message = root.querySelector('[data-pk-message]');
      const moneyFormat = root.dataset.moneyFormat;
      let selectedVariant = variants.find((variant) => String(variant.id) === String(variantInput.value));
      let selectedQuantity = Number(quantityInput.value || 1);

      const updateMainImage = (url, alt, mediaId) => {
        if (!mainImage || !url) return;

        mainImage.classList.add('is-changing');
        mainImage.removeAttribute('srcset');
        mainImage.src = url;
        mainImage.alt = alt || '';
        window.setTimeout(() => mainImage.classList.remove('is-changing'), 120);

        root.querySelectorAll('[data-pk-thumb]').forEach((thumb) => {
          thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(mediaId));
        });
      };

      const updatePrices = () => {
        if (!selectedVariant) return;

        root.querySelectorAll('[data-pk-offer]').forEach((offer) => {
          const quantity = Number(offer.dataset.quantity || 1);
          const price = offer.querySelector('[data-pk-offer-price]');
          const compare = offer.querySelector('[data-pk-offer-compare]');

          if (price) price.textContent = formatMoney(selectedVariant.price * quantity, moneyFormat);
          if (compare) {
            const compareTotal = selectedVariant.compare_at_price * quantity;
            compare.hidden = !selectedVariant.compare_at_price || selectedVariant.compare_at_price <= selectedVariant.price;
            compare.textContent = formatMoney(compareTotal, moneyFormat);
          }
        });

        if (buttonPrice) {
          buttonPrice.textContent = selectedVariant.available
            ? ` ${formatMoney(selectedVariant.price * selectedQuantity, moneyFormat)}`
            : '';
        }

        if (buttonLabel) buttonLabel.textContent = selectedVariant.available ? root.dataset.buttonText : 'Sold out';
        if (buyButton) buyButton.disabled = !selectedVariant.available;
      };

      root.querySelectorAll('[data-pk-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          updateMainImage(thumb.dataset.imageUrl, thumb.dataset.imageAlt, thumb.dataset.mediaId);
        });
      });

      root.querySelectorAll('[data-pk-variant]').forEach((button) => {
        button.addEventListener('click', () => {
          const nextVariant = variants.find((variant) => String(variant.id) === String(button.dataset.variantId));
          if (!nextVariant) return;

          selectedVariant = nextVariant;
          variantInput.value = selectedVariant.id;

          root.querySelectorAll('[data-pk-variant]').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-checked', active ? 'true' : 'false');
          });

          updateMainImage(
            selectedVariant.image_url || button.dataset.imageUrl,
            selectedVariant.image_alt || button.dataset.imageAlt,
            selectedVariant.featured_media_id || button.dataset.mediaId
          );
          updatePrices();

          const url = new URL(window.location.href);
          url.searchParams.set('variant', selectedVariant.id);
          window.history.replaceState({}, '', url);
        });
      });

      root.querySelectorAll('[data-pk-offer]').forEach((offer) => {
        offer.addEventListener('click', () => {
          selectedQuantity = Number(offer.dataset.quantity || 1);
          quantityInput.value = selectedQuantity;

          root.querySelectorAll('[data-pk-offer]').forEach((item) => {
            const active = item === offer;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-checked', active ? 'true' : 'false');
          });

          updatePrices();
        });
      });

      const submitOffer = async () => {
        if (!selectedVariant || !selectedVariant.available || buyButton.disabled) return;

        buyButton.disabled = true;
        buyButton.setAttribute('aria-busy', 'true');
 
        const shopRoot = window.Shopify?.routes?.root || '/';
        const discountCode = root.dataset.discountCode.trim();
        const shouldClearCart = root.dataset.clearCart === 'true';

        try {
          if (!discountCode) throw new Error('Please configure the BOGO discount code in this section.');

          if (shouldClearCart) {
            const clearResponse = await fetch(`${shopRoot}cart/clear.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' }
            });

            if (!clearResponse.ok) throw new Error('Unable to clear the cart.');
          }

          const addResponse = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(selectedVariant.id),
                  quantity: selectedQuantity * 2
                }
              ]
            })
          });

          if (!addResponse.ok) {
            const errorData = await addResponse.json().catch(() => ({}));
            throw new Error(errorData.description || 'Unable to add this offer to the cart.');
          }

         

          const checkoutPath = `${shopRoot}checkout`;
          window.location.assign(
            `${shopRoot}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(checkoutPath)}`
          );
        } catch (error) {
          if (message) message.textContent = error.message || 'Something went wrong. Please try again.';
          buyButton.disabled = false;
          buyButton.removeAttribute('aria-busy');
        }
      };

      buyButton.addEventListener('click', submitOffer);

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitOffer();
      });

      updatePrices();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-pk-product-offer]').forEach(initSection);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
